import {Footer} from "../../components";
import React from "react";
import {Quiz} from "../../components/Forms";

export function CreateQuizPage() {
    return (
        <div>
            <Quiz/>
            <Footer/>
        </div>
    )
}
